import React, { useContext, useRef } from "react";
import styled from "styled-components";
import { dynamicImage } from "../../Utils/DynamicImage/dynamicImage";

const Img = styled.img.attrs((props) => ({
	className: `${props.className || ''}`.trim()
}))``;

const Images = ({ path, ...props }) => {
  return (
    <>
      <Img
        className="img-fluid"
        src={dynamicImage(path)}
        alt="img"
        {...props}
      />
    </>
  );
};

export default Images;
